import React from 'react'

export const SettingsEditContext = React.createContext(null)

const SettingsEditProvider = ({ children }) => {
  const [editObject, setEditObject] = React.useState(null)
  const [save, setSave] = React.useState(null)

  return (
    <SettingsEditContext.Provider
      value={{ editObject, setEditObject, save, setSave }}
    >
      {children}
    </SettingsEditContext.Provider>
  )
}

export default SettingsEditProvider

export function useSettingsEdit () {
  return React.useContext(SettingsEditContext)
}
